import React from 'react';
import i18n, { handleResponseLanguage } from '../../../../../i18n';

const getOldFormat = (_title, _detail) => {
  let detail, title;
  // First check if _detail has the language
  if (
    handleResponseLanguage(_detail) ||
    handleResponseLanguage(_detail) === ''
  ) {
    // If _detail has the language, set the detail to the content of that language
    detail = handleResponseLanguage(_detail);
  } else if (typeof _detail === 'string') {
    // If _detail is a string, set that string as the detail message
    detail = _detail;
  } else if (typeof _detail === 'object') {
    // If _detail is an object, do further checks
    if (_detail?.detail) {
      // if _detail has a detail property, do further checks
      if (handleResponseLanguage(_detail?.detail)) {
        // if the _detail.detail has a language set this as the detail message
        detail = handleResponseLanguage(_detail?.detail);
      } else if (typeof _detail?.detail === 'string') {
        // if _detail.detail is a string, set this as the detail message
        detail = _detail?.detail;
      }
    } else if (_detail?.EN || _detail?.en) {
      // Check if the detail has the english language if the set language isn't found
      detail = _detail?.EN || _detail?.en;
    } else if (_detail === null) {
      detail = '';
    } else {
      // If all else fails, convert the _detail to a json and set this as the message
      detail = JSON.stringify(_detail);
    }
  }

  // First check if title has the language
  if (handleResponseLanguage(_title)) {
    // If _title has the language, set the msg to the content of that language
    title = handleResponseLanguage(_title);
  } else if (typeof _title === 'string') {
    // If _title is a string, set that string as the msg
    title = _title;
  } else if (typeof _title === 'object') {
    // If _title is an object, do further checks
    if (_title?.EN || _title?.en) {
      // Check if the msg has the english language if the set language isn't found
      title = _title?.EN || _title?.en;
    } else {
      // If all else fails, convert the _title to a json and set this as the msg
      title = JSON.stringify(_title);
    }
  }
  return { detail, title };
};

export const formatErrorMessage = (_title, _detail, _error) => {
  let title = i18n.t('SERVER_ERROR');
  let detail = '';

  // check for new error response type
  if (_error?.errors?.length > 0) {
    detail = (
      <ul>
        {_error?.errors?.map((row, i) => (
          <li key={i}>{row}</li>
        ))}
      </ul>
    );
  } else {
    detail = getOldFormat(_title, _detail)?.detail;
  }
  if (_error?.message) {
    title = _error?.message;
  } else {
    title = getOldFormat(_title, _detail)?.title;
  }

  return { title, detail };
};
